/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  belongsTo,
  attr,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Account from '@linc-technologies/linced-common/models/finance/account';
import type Person from 'linced-app/models/person';

// Proto: finance.DebtorsReportRow.
export default class Debtor extends Model {
  declare [Type]: 'finance/debtor';

  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @alias('person.id')
  declare person_id: string | null | undefined;

  @alias('person.isLoaded')
  declare personLoaded: unknown;

  @belongsTo('finance/account', { async: true, inverse: null })
  declare accountId: AsyncBelongsTo<Account>;

  @alias('accountId')
  declare account: AsyncBelongsTo<Account>;

  @alias('account.id')
  declare account_id: string | null | undefined;

  // invoiceDebits is the total amount of outstanding non-donation line items.
  @attr('number', { defaultValue: 0 })
  declare invoiceDebits: number;

  // donationDebits is the total amount of outstanding donation line items.
  @attr('number', { defaultValue: 0 })
  declare donationDebits: number;

  // invoiceCredits is the amount of credits against unpaidInvoices.
  @attr('number', { defaultValue: 0 })
  declare invoiceCredits: number;

  // donationCredits is the amount of credits against unpaidDonations.
  @attr('number', { defaultValue: 0 })
  declare donationCredits: number;

  // pia is the amount of unallocated Payments in Advance.
  @attr('number', { defaultValue: 0 })
  declare pia: number;

  // totalBalance is the overall account balance.
  @attr('number', { defaultValue: 0 })
  declare totalBalance: number;

  // debtBalance is the balance of unpaidInvoices after invoiceCredits.
  @attr('number', { defaultValue: 0 })
  declare debtBalance: number;
}
